// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import MUIIcon, { type IconProps } from '@mui/material/Icon';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';

interface Props extends IconProps {
  children?: React.ReactNode;
  color?: IconProps['color'];
  fontSize?: IconProps['fontSize'];
}
export default function Icon({ children, color, fontSize }: Props) {
  return (
    <MUIIcon color={color} fontSize={fontSize} sx={{ minWidth: '1em' }}>
      {children}
    </MUIIcon>
  );
}
